export default __webpack_public_path__ + "static/media/Project05.9556b069.jpg";